import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ToolBarSpacerViewModelType from '@/ViewModels/Controls/ToolBarSpacerViewModel';

export default class ToolBarSpacer extends Control {

    private jQueryControl: JQuery;

    public constructor(private viewModel: ToolBarSpacerViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');
        this.jQueryControl.addClass('c-separator');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'toolbarspacer',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible
        });
    }
}

ComponentManager.setControl('ToolBarSpacer', ToolBarSpacer, 'RADPresentation.HTMLClient.DefaultViewExtensions');